import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=b9ee806e&scoped=true&"
import script from "./NoSidebar.vue?vue&type=script&lang=js&"
export * from "./NoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ee806e",
  null
  
)

export default component.exports